<template>
    <span class="field-validation-result" v-if="show">
        <span v-html="message"></span>
    </span>
</template>





<script>
export default {

	props: {
		/**
		 * The validation result message to display.
		 */
		message: {
			type: [String, undefined],
			required: true,
		},
	},



	watch: {
		message: function(to, from)
		{
			this.messageValue = to;
			this.calculateShow();
		},
	},



    mounted()
    {
        //console.log("field-validation-result.mounted()");
        this.init();
    },



    updated()
    {
        //console.log("field-validation-result.updated()");
        this.init();
    },



	data: function()
	{
		return {
			messageValue: "",
			show: false
		};
	},



    methods: {
		init()
		{
			this.messageValue = this.message;

			this.calculateShow();
		},



		/**
		 * Calculate if the message should be shown.
		 */
        calculateShow()
        {
            if (this.messageValue != "")
            {
                this.show = true;
            }
        }
    }
}
</script>





<style lang="scss" scoped>
    .field-validation-result
    {
        color:red;
		display: block;
		font-size: 75%;
    }
</style>